import * as ForceChapterCoverActions from "actions/ForceChapterCoverActions";
import * as UserInteractionActions from "actions/UserInteractionActions";
import ChapterCoverComponent from "components/ChapterCoverComponent";
import find from "lodash/find";
import getAdPlaying from "selectors/ads/getAdPlaying";
import getAdRequiresDirectUserInteraction from "selectors/ads/getAdRequiresDirectUserInteraction";
import getPlaybackState from "selectors/chapter/getPlaybackState";
import getShowStoryCoverPosterImage from "selectors/device/getShowStoryCoverPosterImage";
import getShowTitleInNavOnChapterCover from "selectors/breakpoint/getShowTitleInNavOnChapterCover";
import getUseCanvasVideo from "selectors/device/getUseCanvasVideo";
import getUsePersistentVideo from "selectors/device/getUsePersistentVideo";
import getWaitingForInitialPlay from "selectors/device/getWaitingForInitialPlay";
import getPrimaryChapterVideoId from "selectors/chapter/getPrimaryChapterVideoId";
import { compose, withProps } from "recompose";
import { connect } from "react-redux";
import { reportActivity } from "actions/InactivityActions";

const connector = connect(
  (state, ownProps) => {
    const chapterMeta = find(
      state.story.chapters,
      ({ id }) => id === ownProps.chapterId,
    );
    const chapter =
      state.story.entities[chapterMeta.schema][ownProps.chapterId];

    const adRequiresDirectUserInteraction = getAdRequiresDirectUserInteraction(
      state,
      ownProps,
    );
    const adPlaying = getAdPlaying(state, ownProps);
    const showPoster = getShowStoryCoverPosterImage(state, ownProps);
    const playbackState = getPlaybackState(state, ownProps);

    return {
      // This is super hacky and needs to be fixed. We need to send playing if we're actually
      // playing or if we're waiting for an intial play while not using canvas video. the
      // calculation for using canvas video uses if we're waiting for an initial play, which is
      // passed from video.jsx. this will hack the value to use the same calculation it's going to
      // use downstream.
      adRequiresDirectUserInteraction,
      chapterTitle: chapter.title,
      disableAds: !getAdRequiresDirectUserInteraction(state, ownProps),
      embedded: state.route.embedded,
      playing:
        playbackState.playing ||
        (getWaitingForInitialPlay(state, ownProps) &&
          getUseCanvasVideo(state, ownProps)),
      receivedUserInteraction: state.userInteraction.receivedUserInteraction,
      showClickArea: !adPlaying,
      showCoverTitle: !getShowTitleInNavOnChapterCover(state, ownProps),
      showPoster,
      thumbnailId: chapter.thumbnail,
      usePersistentVideo: getUsePersistentVideo(state, ownProps),
      videoId: getPrimaryChapterVideoId(state, ownProps),
      waitingForInitialPlay: getWaitingForInitialPlay(state, ownProps),
    };
  },
  (dispatch) => ({
    reportActivity: () => dispatch(reportActivity()),
    onReceivedUserInteraction: () => {
      dispatch(reportActivity());
      dispatch(UserInteractionActions.receivedUserInteraction());
      dispatch(ForceChapterCoverActions.setForceChapterCover(false));
    },
    onUserInteractionInitiatedPlayback: () =>
      dispatch(UserInteractionActions.userInteractionInitiatedPlayback()),
  }),
);

export default compose(
  withProps(() => ({
    stateKey: "story",
  })),
  connector,
)(ChapterCoverComponent);
